import { createSelector } from 'reselect';


export function getPracticesEfectores(state) {
  return state.practicesefectores;
}

export function getPracticeEfectoresById(state, practiceEfectoresId) {
  return getPracticesEfectores(state).get(practiceEfectoresId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentPracticeEfectores = createSelector(
  getPracticesEfectores,
  practicesefectores => practicesefectores.get(practicesefectores.get('currentPracticeEfectoresId'))
);
